import { render, staticRenderFns } from "./desc_list.vue?vue&type=template&id=f5506f5a&scoped=true"
import script from "./desc_list.vue?vue&type=script&lang=ts"
export * from "./desc_list.vue?vue&type=script&lang=ts"
import style0 from "./desc_list.vue?vue&type=style&index=0&id=f5506f5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5506f5a",
  null
  
)

export default component.exports